export default {
    methods: {
      downloadDocument(name, resp, documentdata) {
        let fileURL = window.URL.createObjectURL(new Blob([resp],{type: 'application/pdf'}));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', name+'.'+documentdata.extension);
        document.body.appendChild(fileLink);
        fileLink.click();           
      }
    }
  };